<style lang="scss" scoped>
.applications {
	&__single {
		margin-bottom: 30px;
	}
	/deep/ .el-col {
		min-height: 170px;
	}
}
</style>

<template lang="pug">
    .applications(v-if="!$apollo.loading")
        el-row(:gutter='30', v-if="resultsNotEmpty")
            el-col(:xs="24", :sm="24", :md="12", :lg="12", :xl="12", v-for="c in orderedCompanies", :key="c.id")
                application(:company="c").applications__single
        application-request
</template>

<script>
import Application from "./ApplicationRow";
import ApplicationRequest from "./ApplicationRequest";
import gql from "graphql-tag";
import { sortBy } from "lodash";

export default {
	components: {
		Application,
		ApplicationRequest
	},

	computed: {
		resultsNotEmpty() {
			return this.Companies && this.Companies.results && this.Companies.results.length;
		},
		orderedCompanies() {
			if (this.Companies && this.Companies.results) {
				return sortBy(this.Companies.results, [company => company.name.toLowerCase()]);
			}

			return [];
		}
	},

	apollo: {
		Companies: {
			query: gql`
				query GetCompanies($cursor: Int, $search: String) {
					Companies(cursor: $cursor, search: $search) {
						cursor
						results {
							id
							name
							slug
							application_logo
							application_description
							application_short_description
						}
					}
				}
			`,
			debounce: 500,
			variables() {
				return {
					cursor: 1,
					search: this.$route.query.search
				};
			}
		}
	}
};
</script>